import React from 'react';
import { STATUS_APPLICATION_SUPPLY } from 'helpers/constants';
import { Select } from 'components/ui/formik';
import Form from '../form';
import styles from '../../../order.module.scss';

const User = ({ edit, values }) => {
  const isDisabled = [
    STATUS_APPLICATION_SUPPLY.CHECK,
    STATUS_APPLICATION_SUPPLY.WAIT,
  ].every(status => status !== Number(edit.status));

  const isChangedStatus = edit.status !== Number(values.status);

  return (
    <>
      <div className={styles.item}>
        <Select disabled={isDisabled} label="Статус" name="status">
          {[
            ...(isDisabled ? STATUS_APPLICATION_SUPPLY.list() : [
              STATUS_APPLICATION_SUPPLY.list().find(status => status === Number(edit.status)),
              STATUS_APPLICATION_SUPPLY.CANCEL,
            ]),
          ].map(value => (
            <option value={value} key={value}>
              {STATUS_APPLICATION_SUPPLY.toString(value)}
            </option>
          ))}
        </Select>
      </div>
      {isChangedStatus ? (
        <Form />
      ) : null}
    </>
  );
};

export default User;
